import {NgModule} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { PulsePerformanceTabsComponent } from './pulse-performance-tabs.component';
import { PerfMetricsModule } from '../perf-metrics/perf-metrics.module';
import { InsightsDepartmentPerformanceModule } from '../insights-department-performance/insights-department-performance/insights-department-performance.module';
import { DropdownModule, EmptyStateSearchModule, TabLineModule } from '@xref/xref-lib';
import { AppPaginationModule } from '../pagination/pagination.module';
import { LoaderModule } from '../loader/loader.module';


@NgModule({ declarations: [PulsePerformanceTabsComponent],
    exports: [PulsePerformanceTabsComponent], imports: [BrowserModule,
        FormsModule,
        PerfMetricsModule,
        InsightsDepartmentPerformanceModule,
        DropdownModule,
        EmptyStateSearchModule,
        TabLineModule,
        AppPaginationModule,
        LoaderModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class PulsePerformanceTabsModule { }
